<template>
  <v-row>
    <v-col cols="12" sm="6" offset-sm="3">
      <v-card>
        <v-container fluid>
          <!-- <h2 class="text-center my-2">{{ $t("other.photo_booking") }}</h2> -->
          <v-row v-if="photos.length > 0">
            <v-col
              v-for="(item, index) in sortedPhotos"
              :key="item.id"
              class="d-flex child-flex"
              cols="4"
            >
              <v-card flat tile class="d-flex flex-column my-2">
                <media-thumb
                  :src="source(item)"
                  :content-type="item.content_type"
                  @click="showGallery(index)"
                />
                <v-row justify="center" class="mt-5 align-center d-flex">
                  <v-icon
                    class="mr-1"
                    color="blue-grey"
                    @click="showGallery(index)"
                  >
                    mdi-magnify
                  </v-icon>
                  <v-icon
                    class="mr-1"
                    color="warning"
                    @click="deleteItem(item)"
                  >
                    mdi-delete-forever
                  </v-icon>
                  <v-icon class="" color="info" @click="downloadItem(item)">
                    mdi-content-save-outline
                  </v-icon>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" v-if="page < totalPages" class="d-flex justify-center">
              <v-btn @click="loadMorePhotos" :loading="isLoadingLoadMore">
                {{ $t("custom.load_more") }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-else-if="photos.length == 0 && !isLoadingLoadMore" class="d-flex text-center justify-center my-3">
            <v-card flat tile class="d-flex text-center justify-center">
              {{ $t("other.no_photo") }}
            </v-card>
          </v-row>
          <v-row v-else class="d-flex text-center justify-center my-3">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
    <MediaLightbox ref="lightbox" :items="media"></MediaLightbox>
  </v-row>
</template>
<script>
import { saveAs } from "file-saver";
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import draggable from "vuedraggable";
import MediaLightbox from "@/components/MediaLightbox.vue";
import MediaThumb from "@/components/MediaThumb.vue";
import { toLightboxItems } from "@/utils/mediaLightbox";
import CarDamageMarker from './CarDamageMarker.vue'
export default {
  props: {
    booking_id: {
      type: Number,
      required: true,
    },
    newPhotos: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      photos: [],
      page: 1,
      per_page: 9,
      totalPages: 0,
      link_full_image: "",
      dialog: false,
      isLoadingLoadMore: false,
      bookingDamages: null,
      isLoadingDamages: false,
    };
  },
  created() {
    this.getPhotos();
  },
  watch: {
    newPhotos(newVal) {
      this.photos.push(...newVal)
    }
  },
  computed: {
    // Лайтбокс берёт кадры ОТСЮДА и адресует их индексом сетки, а сетка рисуется из
    // `photos`. Пока это было полем data и пересобиралось только внутри getPhotos,
    // свежезагруженная фотография попадала в сетку, но не в этот массив: индекс уходил
    // за его границу, и по клику не открывалось ничего — до перезахода в бронь.
    //
    // Дефект старше FT-152/FT-153 и их правками не закрывался: `vue#463` чинил
    // ИДЕНТИФИКАТОР карточки, а лайтбокс адресует не по id, а по индексу.
    //
    // Вычисляемое свойство убирает второй источник истины: массив теперь по построению
    // той же длины и того же порядка, что сетка.
    media() {
      return toLightboxItems(this.photos);
    },
    sortedPhotos() {
      return this.photos;
      // if (this.photos && this.photos.length > 0) {
      //   return this.photos.sort((a, b) => {
      //     return b.position - a.position;
      //   });
      // } else {
      //   return [];
      // }
    },
    isNative() {
      return Capacitor.isNativePlatform();
    },
    checkWriteFile() {
      return Capacitor.isNativePlatform() && Filesystem.checkPermissions();
    },
    requestPermissionsWriteFile() {
      return Filesystem.requestPermissions();
    },
  },
  methods: {
    getPhotos() {
      this.isLoadingLoadMore = true;
      this.axios
      .get(`api/v1/booking_photos_v2/${this.booking_id}`, {
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
        params: {
          page: this.page,
          per_page: this.per_page,
        },
      })
      .then((response) => {
        // Если первая страница, то обновляем массив photos
        if (this.page === 1) {
          this.photos = response.data.photos;
        } else {
          this.photos.push(...response.data.photos);
        }
        this.totalPages = response.data.meta.total_pages;
      })
      .catch((error) => {
        this.setError(error, this.$t("errors.load_file"));
        console.log(error);
      })
      .finally(() => {
        this.isLoadingLoadMore = false;
      });
    },
    loadMorePhotos() {
      if (this.page < this.totalPages) {
        this.page++;
        this.getPhotos();
      }
    },
    screenFullImage(item) {
      this.isLoading = true;
      this.axios
        .get(`api/v1/booking_photos_full/${item.id}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          // Фотография, загруженная секунду назад, ещё может не иметь файла: строка
          // заводится подписью, а image_data проставляет ProcessBookingPhotoJob уже
          // после ответа confirm_upload (`202 {status:"processing"}`). Тогда сервер
          // честно отдаёт url: null, и открывать пустой диалог незачем.
          if (!response.data.url) {
            this.$notify(this.$t("bookings.photo_still_processing"), "", "info", 4000);
            return;
          }
          this.link_full_image = response.data.url;
          this.dialog = true;
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showGallery(index) {
      console.log('showGallery')
      this.$refs.lightbox.open(index)
    },
    async downloadItem(item) {
      this.isLoading = true;
      this.axios
        .get(`api/v1/booking_photos_full/${item.id}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          // То же окно, что и в screenFullImage: скачивать ещё нечего.
          if (!response.data.url) {
            this.$notify(this.$t("bookings.photo_still_processing"), "", "info", 4000);
            return;
          }
          if (!this.isNative) {
            saveAs(`${response.data.url}`);
          } else {
            this.downloadFileToMobile(response.data.url);
          }
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    downloadFileToMobile(item_url) {
      if (Filesystem.checkPermissions()) {
        // Сначала получаем Blob из URL
        fetch(item_url)
          .then(response => response.blob())
          .then(blob => {
            // Теперь у нас есть настоящий Blob объект
            const getBase64FromBlob = async (blob) => {
              return new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                  const base64data = reader.result;
                  resolve(base64data);
                }
              });
            }

            return getBase64FromBlob(blob);
          })
          .then((base64) => {
            // Определяем расширение файла
            let fileExtension = '';

            // Пытаемся получить расширение из URL
            const urlExtMatch = item_url.match(/\.([^./?#]+)($|\?|#)/);
            if (urlExtMatch) {
              fileExtension = `.${urlExtMatch[1].toLowerCase()}`;
            }
            // Если не удалось получить из URL, пытаемся определить из MIME-типа в base64
            else if (base64.startsWith('data:')) {
              const mimeMatch = base64.match(/^data:([^;]+);/);
              if (mimeMatch) {
                const mimeType = mimeMatch[1].toLowerCase();
                if (mimeType.startsWith('image/')) {
                  fileExtension = `.${mimeType.split('/')[1]}`;
                } else if (mimeType === 'application/pdf') {
                  fileExtension = '.pdf';
                } else if (mimeType.startsWith('video/')) {
                  fileExtension = `.${mimeType.split('/')[1]}`;
                } else if (mimeType.startsWith('audio/')) {
                  fileExtension = `.${mimeType.split('/')[1]}`;
                }
              }
            }

            // save file
            async function writeFile() {
              return await Filesystem.writeFile({
                path: `photo_${Date.now()}_${Math.floor(Math.random() * 1000)}${fileExtension}`,
                data: base64,
                directory: Directory.Documents,
              });
            }

            writeFile().then((getUriResult) => {
              // share file opened file
              let shareFile = async () => {
                await Share.share({
                  title: 'Download document',
                  files: [getUriResult.uri],
                }).catch((error) => {
                  console.log("shareFile", error)
                });
              };

              shareFile();
            }).catch((error) => {
              console.log("shareFile", error)
            });
          })
          .catch(error => {
            console.log("Error getting base64:", error);
          });
      } else {
        Filesystem.requestPermissions();
      }
    },
    source(item) {
      if (item.content_type && item.content_type.split("/")[0] == "video") {
        return "/img/play-button96.png";
      } else {
        return item.small_url ? item.small_url : item.url;
      }
    },
    deleteItem(item) {
      if (this.isStaff) {
        this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("custom.you_sure_text"),
          icon: "mdi-alert-circle-outline",
          confirmButtonText: this.$t("custom.you_sure_yes"),
          cancelButtonText: this.$t("custom.you_sure_no"),
        }).then((result) => {
          if (result) {
            this.axios
              .delete(`/api/v1/booking_photos/${item.id}`, {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              })
              .then((response) => {
                this.photos.splice(this.photos.indexOf(item), 1);
                this.$notify(this.$t("custom.deleted"), this.$t("other.delete_file"), "success", 2000);
              })
              .catch((error) =>
                this.setError(error, this.$t("errors.delete_file"))
              );
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    movePhoto(e) {
      let photo_id = this.photos[e.oldIndex].id;
      this.photos.splice(e.newIndex, 0, this.photos.splice(e.oldIndex, 1)[0]);
      let self = this;
      // console.log(e.newIndex, e.oldIndex);
      // this.photos.forEach((item) => {
      //   item.sort = self.photos.indexOf(item);
      // });
      this.isLoading = true;
      this.axios
        .patch(`api/v1/booking_photos_sorting/${photo_id}`,
          {
            booking_photos: {
              new_position: e.newIndex + 1,
              old_position: e.oldIndex + 1,
            },
          },
          {
            headers: {
              Authorization: self.$store.getters.getAuthToken,
            },
          }
        )
        .then(() => {
          // this.photos = this.photos.sort((a, b) => {
          //   return a.sort - b.sort;
          // });
          this.$notify(this.$t("custom.saved"), "", "success", 3000);
        })
        .catch((error) => this.setError(error, this.$t("errors.error")))
        .finally(() => (this.isLoading = false));
    },
    sortUp(item) {
      if (this.isStaff) {
        this.isLoading = true;
        let self = this;
        this.axios
          .get(`api/v1/booking_photos/sort_up/${item.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then(() => {
            item.sort += 1;
            let foundIndex = self.photos.findIndex(
              (element) => element.id === item.id
            );
            this.photos.splice(foundIndex, 1, item);
            this.$notify(this.$t("other.sort_files_title"), this.$t("other.sort_files_text"), "success");
          })
          .catch((error) => this.setError(error, this.$t("errors.sort_file")))
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    sortDown(item) {
      if (this.isStaff) {
        this.isLoading = true;
        let self = this;
        this.axios
          .get(`api/v1/booking_photos/sort_down/${item.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then(() => {
            item.sort -= 1;
            let foundIndex = self.photos.findIndex(
              (element) => element.id === item.id
            );
            this.photos.splice(foundIndex, 1, item);
            this.$notify(this.$t("other.sort_files_title"), this.$t("other.sort_files_text"), "success");
          })
          .catch((error) => this.setError(error, this.$t("errors.sort_file")))
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
  },
  components: {
    MediaLightbox,
    MediaThumb,
  },
};
</script>
